/**
 * Recuerda en el navegador si el constructor ya vio la guía y si está abierta. Se inicia
 * en la primera visita a una aplicación y puede volver a abrirse desde la ayuda.
 *
 * Guarda la versión vista. Incrementar GUIDE_VERSION permite mostrar de nuevo una guía
 * que haya cambiado sustancialmente.
 */

const KEY = "plane-guia";

/** La versión del recorrido. Subirla lo vuelve a enseñar una vez. */
const GUIDE_VERSION = 1;

/** Si ya se vio esta versión. Sin memoria del navegador, nunca se dio por vista. */
function seen(): boolean {
  try {
    return localStorage.getItem(KEY) === String(GUIDE_VERSION);
  } catch {
    // Sin memoria, la guía sale una vez por pestaña y no se puede hacer más.
    return false;
  }
}

/**
 * Recuerda en este navegador que la guía ya se vio. Sin almacenamiento, dura lo que dure la
 * pestaña.
 */
function remember(value: boolean): void {
  try {
    if (value) localStorage.setItem(KEY, String(GUIDE_VERSION));
    else localStorage.removeItem(KEY);
  } catch {
    /* sin memoria del navegador la eleccion dura lo que dure la pestana */
  }
}

let open = $state(false);
let pending = $state(!seen());

export const guide = {
  /** Si el recorrido está abierto. Lo dibuja `GuideTour`, montado en `App`. */
  get open(): boolean {
    return open;
  },
  /** Abrirla a mano, desde el botón de ayuda del encabezado. */
  show(): void {
    open = true;
  },
  /** Abrirla al entrar a una aplicación, solo si todavía no se ha visto. */
  showOnce(): void {
    if (pending) open = true;
  },
  /**
   * Cerrarla, y darla por vista.
   *
   * Cerrar cuenta igual que terminar a propósito: quien la corta a la mitad no
   * quiere encontrarsela otra vez en la siguiente aplicación. Para volver a
   * verla está el botón de ayuda del encabezado.
   */
  close(): void {
    open = false;
    if (pending) {
      pending = false;
      remember(true);
    }
  },
};
